export var TransientPlayMode;
(function (TransientPlayMode) {
    TransientPlayMode[TransientPlayMode["Once"] = 0] = "Once";
    TransientPlayMode[TransientPlayMode["Repeat"] = 1] = "Repeat";
    TransientPlayMode[TransientPlayMode["Pingpong"] = 2] = "Pingpong";
})(TransientPlayMode || (TransientPlayMode = {}));
